export const INVOCA_PHONE_NUMBER = "855-306-2979"; // in future, evaluate Sanity config for phone and strings
export const INVOCA_PHONE_NUMBER_DISPLAY = "(855) 306-2979";

// these numbers are not currently used - they were for O&O on VT/Shallow/Lander 2.0
// export const SHALLOW_PHONE_NUMBER = "402-588-5226";
// export const SHALLOW_PHONE_NUMBER_DISPLAY = "(402) 588-5226";
